import { Box, Typography, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { personalized } from "helpers/product/image-url"

const UnderlineText = styled(Typography).attrs((props) => ({
  color: "primary",
  display: "inline-block",
  fontSize: "18px",
  mb: { _: 4, tablet: 0 },
  ...props,
}))`
  text-decoration: underline;
  :hover,
  :active {
    text-decoration: none;
  }
`
const ShopWatch = ({ data, title }) => (
  <Box contain mb={{ _: 5, tablet: 6 }} textAlign="center">
    <Typography fontSize={25} mb={4}>
      {title}
    </Typography>
    <Box
      display={{ _: data.length > 3 ? "flex" : "block", tablet: "flex" }}
      flexWrap={{ _: "wrap", tablet: "no-wrap" }}
    >
      {data.map((item) => (
        <Box
          as={Link}
          data-lc="shop-watch"
          flex={{
            _: data.length > 3 ? "50%" : 1,
            tablet: data.length > 3 ? "25%" : 1,
          }}
          key={`watch-${item.folder}`}
          mb={4}
          px={{ tablet: 1 }}
          to={item.link}
        >
          <Image
            alt={item.title}
            data-src={personalized(item.folder, "product")}
            height={{ _: "215px", desktop: "224px", tablet: "152px" }}
            src={require("images/icons/jewlr.gif")}
            srcSet={`
              ${personalized(item.folder, "xlarge")} 767w,
              ${personalized(item.folder, "xlarge")}
              450w
              `}
            width={{ _: "215px", desktop: "224px", tablet: "152px" }}
          />
          <UnderlineText>{item.text}</UnderlineText>
        </Box>
      ))}
    </Box>
  </Box>
)

ShopWatch.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
}
export default ShopWatch
